<template>
  <div
    v-if="showDisclaimer"
    class="flex flex-row justify-start"
  >
    <p class="text-EXPONDO-grey-60 text-left text-xs leading-4">
      {{ $t('Minimum price in the last 30 days before the discount:') + ' ' + $n(last30DaysPrice, 'currency') }}
    </p>
  </div>
</template>

<script lang="ts">



export default defineComponent({
  name: 'PriceDisclaimer',
  props: {
    isDiscounted: {
      type: Boolean,
      default: false,
    },
    last30DaysPrice: {
      type: Number,
      default: null,
    },
  },
  setup (props) {

    const { isPriceDisclaimerEnabled } = usePriceDisclaimer();
    const showDisclaimer = computed(() =>
      isPriceDisclaimerEnabled.value &&
      props.isDiscounted &&
      props.last30DaysPrice !== null,
    );

    return {
      showDisclaimer,
    };
  
  },
});

</script>
